<template>
  <div>

    <validation-provider
      #default="{ errors }"
      :name="errorName"
      :rules="rules"
    >
      <b-form-group
        :state="errors.length > 0 ? false:null"
      >
        <label :for="id">{{ label }}</label>
        <v-select
          :id="id"
          v-model="innerValue"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="options"
          :placeholder="placeholder"
          :label="item"
          :clearable="clearable"
          :value="value"
          :disabled="readonly"
          :reduce="reduce"
          :multiple="multiple"
          @input="setSelected"
        >
          <template v-slot:spinner="{}">
            <b-spinner
              v-if="loading"
              variant="primary"
              small
            />
          </template>
        </v-select>

        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

  </div>
</template>

<script>
import { BFormGroup, BFormInvalidFeedback, BSpinner } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'SelectField',
  components: {
    BFormGroup,
    BSpinner,
    BFormInvalidFeedback,
    vSelect,
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    clearable: {
      type: Boolean,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    reduce: {
      type: Function,
      default: null,
    },
    item: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: [Object, String, Number, Boolean, Array],
      required: false,
      default: null,
    },
    setSelected: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      innerValue: '',
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
